import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectState = state => {
  const appState = state || redux.store.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectLocations = state => selectState(state).data;
export const selectLocationLoading = state => selectState(state).loading;
export const selectLocationError = state => selectState(state).error;
